import { apiPost } from "../client";
import type { ICreateExamAssignmentInput, IExamAssignment } from "./types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export async function createExamAssignment(input: ICreateExamAssignmentInput) {
  const response = await apiPost<IExamAssignment>("/exam_assignments", input);
  return response.data;
}

export function useCreateExamAssignment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createExamAssignment,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["examAssignments"] });
    },
  });
}
